module.exports = __webpack_public_path__ + "img/icon_filter.e2e0903b.svg";